/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { RouterView } from "vue-router";
import { useAuth } from "../providers";
import { useTheme } from "@lemmonhq/uikit";
import { isMobileTabBarPrototypeEnabled } from "../components/LayoutComponents/Navbar/mobileTabBarPrototype";

export const Application = defineComponent({
  name: "Application",
  setup() {
    onMounted(() => {
      const styleString = `html, body {  scrollbar-gutter: initial !important; overflow: hidden; }`;
      const style = document.createElement("style");
      style.textContent = styleString;
      (document as any).head.append(style);
    });
    const auth = useAuth();
    const { currentTheme } = useTheme();
    const useMobileTabBar = isMobileTabBarPrototypeEnabled();

    return () => {
      // important: a lot of frontend code relies on having auth.user.value present
      if (auth.user.value?.id) {
        return (
          <div
            data-theme={currentTheme.value}
            style={{
              height: `calc(100vh - 64px - var(--safe-area-top, 0px))`,
            }}
            class={[
              "flex flex-col overflow-hidden",
              useMobileTabBar
                ? "max-[698px]:!h-auto max-[698px]:min-h-0 max-[698px]:flex-1"
                : "",
            ]}
          >
            <RouterView />
          </div>
        );
      }
      return null;
    };
  },
});
